import { Pipe, PipeTransform } from '@angular/core';

import { DateTimeHelperService, emptyTime } from '@mirage-projects/cw-utils';

type millisecondsParam = Parameters<DateTimeHelperService['millisecondsToHHMMSS']>[0];

@Pipe({
    name: 'msToHHMMSS',
    standalone: false,
})
export class MsToHHMMSSPipe implements PipeTransform {
    constructor(private dateTimeHelperService: DateTimeHelperService) {}

    transform(milliseconds?: millisecondsParam, stringIfEmpty = emptyTime): string {
        if (!milliseconds) {
            return stringIfEmpty;
        }
        const timeFormated = this.dateTimeHelperService.millisecondsToHHMMSS(milliseconds);

        return timeFormated;
    }
}
